module.exports = __webpack_public_path__ + "static/media/hands-people-woman-working.14b7d5af.jpg";